import BagSvg from "./SidebarSVG/BagSvg";
import SidebarNavLink from "./sidebarNavLink";
import "./style.scss";
import { RequestSvg } from "./SidebarSVG/RequestSvg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserRolesId } from "../../pages/enum";

const SidebarContent = () => {
  const { t } = useTranslation();
  const userInfo = useSelector((state: any) => state.user.user);
  const navigate = useNavigate();

  const adminSidebarData = [
    // {
    //   text: "dashboard",
    //   link: "/dashboard",
    //   icon: <CircleSvg />,
    // },
    ...(userInfo?.roleId !== UserRolesId.Provider
      ? [
          {
            text: t("sidebar.providers"),
            link: "/providers",
            icon: <BagSvg />,
          },
        ]
      : []),

    {
      text: t("sidebar.requests"),
      link: "/requests",
      class: "requests",
      icon: <RequestSvg />,
    },

    ...(userInfo?.roleId === UserRolesId.Provider
      ? [
          {
            text: t("sidebar.company"),
            link: `/add-provider/${userInfo?.serviceProviderId}`,
            icon: <BagSvg />,
          },
        ]
      : []),

    ...(userInfo?.roleId === UserRolesId.Sponsor
      ? [
          {
            text: t("sidebar.company"),
            link: `/add-company/${userInfo?.sponsorId}`,
            icon: <BagSvg />,
          },
        ]
      : []),

    {
      text: t("sidebar.results"),
      link: "/request-results",
      class: "requests",
      icon: <RequestSvg />,
    },

    ...(userInfo?.roleId === UserRolesId.Admin
      ? [
          {
            text: t("companies.companies"),
            link: "/companies",
            class: "requests",
            icon: <RequestSvg />,
          },
        ]
      : []),

    {
      text: t("sidebar.approvals"),
      link: "/approvals",
      class: "requests",
      icon: <RequestSvg />,
    },

    // {
    //   text: "clients",
    //   link: "/clients",
    //   icon: <PeopleSvg />,
    // },
    // {
    //   text: "services",
    //   link: "/services",
    //   icon: <HospitalSvg />,
    // },
  ];

  return (
    <div className="sidebar-container">
      <div className="background-image" />
      <div className="gradient-overlay" />

      <img
        onClick={() => navigate("/dashboard")}
        style={{ cursor: "pointer" }}
        src="/assets/logo/logo.svg"
        alt="logo"
        className="logo"
      />

      <div className="separator"></div>

      <nav>
        <ul>
          {adminSidebarData.map((navLink, idx) => (
            <li key={`${navLink.text}-${idx}`}>
              <SidebarNavLink
                text={navLink.text}
                classes={navLink?.class}
                link={navLink.link}
                icon={navLink.icon}
              />
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default SidebarContent;
